<h2 mat-dialog-title>Vedi pagamento effettuato</h2>

<mat-dialog-content>
  <p>Qui puoi controllare il pagamento effettuato.</p>

  <p>Stato pagamento: <strong>{{ getActiveValueDisplay(data.payment.status) }}</strong></p>

  <p>Il pagamento è stato effettuato con {{data.payment.method}} in data {{data.payment.date | date : "dd/MM/yyyy" }}, per un importo di € {{data.payment.amount}}. </p>

  <!-- <form [formGroup]="paymentForm">
    <div class="d-flex justify-content-between align-items-center me-0 mb-2">
      <span>Rinnovo automatico</span>
      <span>
        <mat-form-field
          formControlName="external_link"
          color="primary"
          class="mt-2"
          matTooltip="Vedi link."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
        >
        </mat-form-field>
      </span>
    </div>
  </form> -->

  <div *ngIf="isLoading" class="text-center mt-3">
    <mat-spinner diameter="30"></mat-spinner>
    <p class="mt-2">Aggiornamento in corso...</p>
  </div>

  <mat-divider></mat-divider>

  <p class="mt-3">La ricevuta è disponibile al seguente link:</p>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Link ricevuta</mat-label>
    <textarea
      matInput 
      [value]="external_link" 
      readonly
      rows="2"
      #linkInput>
    </textarea>
    <button 
      mat-icon-button 
      matSuffix 
      (click)="copyToClipboard()"
      [attr.aria-label]="'Copia link'">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <button 
    mat-raised-button 
    (click)="openPaymentAttachment(data.payment.attached_receipt)"
    class = "mt-1 mb-3 w-100"
    >
  <mat-icon matChipAvatar>attach_file</mat-icon> 
    Apri qui il PDF del pagamento
  </button>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isLoading">Indietro</button>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="confirm()"
    [disabled]="isLoading || paymentForm.invalid"
  >
    <mat-icon>check</mat-icon>
    Ok
  </button>
</mat-dialog-actions>
